<template>
  <div class="page page-login" id="page-login">
    <van-nav-bar title="实名"/>
    <div style="color:red;margin-top:10px;margin-left:10px;">完成个人信息填写成为专属会员，领取会员奖励</div>
      <van-divider />
      <div class="login-form">
        <van-field v-model="realname" label="姓名" placeholder="请输入姓名"/>
        <van-field v-model="idcard" label="身份证号" placeholder="请输入身份证号" />
        <van-button round @click="submit" block="" type="info" style="margin-top:10px;">提交</van-button>
      </div>
  </div>
</template>
<script>
import { CellGroup, Col, Divider, NavBar, Row } from "vant";
import { Sticky } from "vant";
import { Popup } from "vant";
import { Button, Field } from "vant";
import AppVue from '../../App.vue';
export default {
  data() {
    return {
      smsLoading: false,
      realname: "",
      idcard: "",
      active: 0,
      user: {},
    };
  },
  computed: {
    loginshow: {
      get() {
        return this.$store.state.loginShow;
      },
      set() {
        this.$store.commit("hideLogin");
      },
    },
    cartNum(){
      return this.$store.state.cartCount;
    }
  },
  methods: {
    ShowLogin() {
      this.$store.commit("showLogin");
    },
    submit() {
      var that = this;
      if(this.realname==""){
        // that.$toast("请填写姓名");
        return this.$toast.fail("请填写姓名");
      }
      if(this.idcard==""){
        // that.$toast("请填写身份证");
        return this.$toast.fail("请填写身份证号");
      }
      this.$http.get("Activity2025/MemberAuth", {
          params: {
            realname: this.realname,
            idcard: this.idcard
          },
        }).then((res) => {
          if (res.data == "success") {
            that.$toast.success("认证成功");
            that.$router.push({
                name: "MyCenter",
                params: {},
            });
          }else{
            that.$toast(res.data);
          }
        });
    },
  },
  mounted() {

    var that = this;
    this.$http.get("SDWorker/CheckLogin").then((res) => {
      if (res.data == "success") {
        that.$store.commit("login");
        that.$store.commit("hideLogin");        
      }
    });    
  },
  beforeMount() {
    var h = document.documentElement.clientHeight || document.body.clientHeight;

    this.curHeight = h - 50; //减去页面上固定高度height
  },
  components: {
    [NavBar.name]: NavBar,
    [Sticky.name]: Sticky,
    [Button.name]: Button,
    [Popup.name]: Popup,
    [Field.name]: Field,
    [CellGroup.name]: CellGroup,
    [Row.name]: Row,
    [Col.name]: Col,
    [Divider.name]: Divider,
  },
};
</script>
<style scoped>
.loggin-box {
    margin: 20px;
    margin-top: 15%;
    padding: 30px 20px;
    border-radius: 10px;
    background: #fff;
    box-shadow: 1px 1px 20px rgba(0, 0, 0, 0.1);
    position: relative;
    text-align: center;
  }
  .logo {
      position: relative;
      margin-top: -50%;
    }
    .btn-box {
      margin-top: 30px;
    }
  
</style>